export default __webpack_public_path__ + "static/media/29__tag_microwave.4ba4a75a.svg";